<template>
  <div class="section movie">
    <div class="container" id="container">
      <div class="opening waku" v-if="isOpening">
        <div id="game-container"></div>
      </div>
      <div class="movie__wrap" v-if="!isOpening">
        <video :src="require('../assets/movie/welcome.mp4')" autoplay playsinline></video>
      </div>
      <div class="movie__caution">
        <p class="movie__caution__skip" @click="moveNext">SKIP</p>
        <small class="movie__caution__bgm">BGM by OtoLogic(CC BY 4.0)</small>
      </div>
    </div>
  </div>
</template>

<script>
import * as opening from '@/utils/opening';

export default {
  name: 'Movie',
  data() {
    return {
      isOpening : true
    }
  },
  mounted() {
    opening.start(this.finishOpening);
  },
  methods: {
    finishOpening() {
      this.isOpening = false;
    },
    moveNext() {
      if (this.isOpening) {
        opening.cancel();
        return;
      } else {
        this.$router.push({name: '/home', hash: '#castlist'});
      }
    }
  },
  beforeDestroy() {
    opening.destroy();
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/movie.scss';
</style>
